module.exports = __webpack_public_path__ + "static/media/crossword.f4e2917d.png";